import React from 'react';
import { motion } from 'framer-motion';
import { useMetronome } from '../contexts/MetronomeContext';
import { useLanguage } from '../contexts/LanguageContext';

const TimeSignatureSelector = () => {
  const { beatsPerMeasure, updateTimeSignature } = useMetronome();
  const { t } = useLanguage();

  const beatCounts = [2, 3, 4, 5, 6, 7, 8, 9, 12, 16];

  return (
    <div className="mb-6">
      <div className="text-sm font-medium text-gray-700 dark:text-gray-300 text-center mb-2">
        {t('timeSignature')}
      </div>
      <div className="grid grid-cols-5 gap-2 max-w-lg mx-auto">
        {beatCounts.map((count, index) => (
          <motion.button
            key={count}
            onClick={() => updateTimeSignature(count, [0])}
            className={`py-2 rounded-lg ${
              beatsPerMeasure === count
                ? 'border-2 border-indigo-500 bg-white dark:bg-gray-800 text-indigo-600 dark:text-indigo-400'
                : 'border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:border-gray-300 dark:hover:border-gray-500'
            }`}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: index * 0.02 }}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <div className="text-lg font-bold">{count}</div>
          </motion.button>
        ))}
      </div>
    </div>
  );
};

export default TimeSignatureSelector;